import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import printJS from 'print-js'
import Printd from 'printd'
import CryptoJS from 'crypto-js'
import SimpleEncrypt from 'simple-encryptor'
import Pagination from './../../shared/pagination'

import {
	Validator
} from 'vee-validate'
export default {
	name: 'returnsmanifest',

	components: {
		Paginate,
        Pagination,
        moment
	},
	props: ['manifest'],
	data: function() {
		return {
			// initialize form field
			isLoading: false,
			PurchaseOrderDetailsData: [],
			PurchaseOrderLoopData: [],
			clientdata: [],
			supplierdata: [],
			logoUrl: '',

			pono: '0',
			poform: {},
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin"></i> Loading...',
			warehouseid: '',
			clientid: '',
			clientItem: {},
            warehouseItem:{},
            manifestDetails:[],
            awbdetails:[],
            currentPage: 1,
            totalPage: 0,
            totalCount: 0,
            pageLimit: 10,
            isLoading: false,
            manifest_date:''
		}
	}, // end data
	model: {
		totalpricewithtax: 0,
		sgst: 0,
		cgst: 0,
		igst: 0,
		totalpricewithouttaxes: 0,

	},
	computed: {
        startIndex() {
            return (this.currentPage - 1) * this.pageLimit;
          }
	}, // end computed

	created: function() {
		// when a page loads,mounted() will be call
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.user_type = userdetail.utype;
        this.useremail = userdetail.email;
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.addWarehouseList();
        this.getManifestDetails();
		switch (this.user_type) {
            case 'system_user':
                console.log("system_user")
                this.showSelectClient = true;
                this.showSelectWarehouse = true;
                this.createdbyEmail = userdetail.email;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'client_user':
                console.log("client_user")
                this.clientid = this.addChannel.clientid = userdetail.clientid;
                this.createdbyEmail = userdetail.email;
                this.showSelectWarehouse = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'warehouse_user':
                console.log("warehouse_user")
                this.warehouseid = this.addChannel.warehouseid = userdetail.warehouseid;
                this.createdbyEmail = userdetail.email;
                this.showSelectClient = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            default:
                console.log("default")
                this.$alertify.error("Unauthorised user, Please contact your system admin");
                break
		}
	},
	filters: {
		moment: function(date) {
            if (!date) return '';
            return moment(date).format('DD-MM-YY HH:mm:ss');
		}
	},
	methods: {
		showList() {
            // this.modalMessageShowpo = false;
            this.warehouseItem.value=this.warehouseItem.value;
            this.$emit("goBackToParent", this.clientItem, this.warehouseItem)
        },
		addWarehouseList() {
            if (window.localStorage.getItem("warehouseList") !== null) {
                var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
                var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
                var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
                this.getWarehouseSelectOptions(JSON.parse(plaintextwarehouse));
            } else {
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                this.input = ({
                    clientid: this.clientid,
                });

                axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                    .then(result => {
                        this.getWarehouseSelectOptions(result.data.data);
                    }, error => {
                        console.error(error)
                    })
            }
        },
        calculateSerialNumber(index) {
            return this.startIndex + index + 1;
          },
		clientSelected(item) {
            this.clientItem=item;
            if(this.clientid != this.clientItem.value){
                this.addChannel.clientid = item.value;
                this.clientid = this.addChannel.clientid;
                this.addChannel.saleschannel = '';
                this.saleschannellist = [];
                this.salesChannelItem={};
                this.getSalesChannels();
                if (this.user_type != 'warehouse_user') {
                    this.warehouseid='';
                    this.addChannel.warehouseid='';
                    this.listWarehouseData = [];
                    this.warehouseItem={};
                    this.getWarehouseList();
                  }
            }
        },
        warehouseSelected(item) {
            this.warehouseItem=item;
            this.addChannel.warehouseid=window.localStorage.getItem('selectedWarehouse');
            this.addChannel.warehousename=item.text;
            this.warehouseid = this.addChannel.warehouseid;
            if (this.warehouseid) {
                if (!this.clientid) {
                    this.getClientList();
                } else {
                    this.getSalesChannels();
                }
            }
        },
		getClientSelectOptions(data){
            this.clientItem = {
                value: '',
                text: ''
            };
            this.listClientData = [{
                value: '',
                text: this.$t('common.clientPlaceholder')
            }];
            data.forEach(ele => {
                this.listClientData.push({
                    "value": ele.clientid,
                    "text": ele.clientname
                })
            })
        },
        getWarehouseSelectOptions(data){
            this.warehouseItem = {
                value: '',
                text: ''
            };
            this.listWarehouseData = [{
                value: '',
                text: this.$t('common.warehousePlaceholder')
            }];
            data.forEach(ele => {
                this.listWarehouseData.push({
                    "value": ele.warehouseid,
                    "text": ele.warehousename
                })
            })
        },
        onPageChange(page) {
            this.currentPage = page;
            this.getManifestDetails()
          },
        getManifestDetails(){
            var today = new Date();
            //this.manifest_date = moment(today).format('DD/MM/YYYY HH:mm:ss');
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
				manifestid: this.manifest,
				clientid: window.localStorage.getItem("selectedClient"),
                offset: (this.currentPage - 1) * 10,
                limit: this.pageLimit,
			});
            return axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getManifestDetailsById',
                'data': this.input,
                headers: {
                'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.isLoading = false;
                    this.manifestDetails = result.data.data[0];
                    this.awbdetails = result.data.data;
                    this.totalRows =  Number(result.data.count);
                   this.manifest_date = result.data.data[0].createddatetime;
                    if (this.totalRows > 0) {
                      if (this.totalRows <= this.pageLimit) {
                        this.totalPage = 1;
                      } else {
                        this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
                      }
                    } else {
                      this.totalPage = 0;
                    }
                }, error => {
                console.error(error);
                });

        }

				
	} // end methods
}


// WEBPACK FOOTER //
// ./src/views/components/returnsmanifestlist/viewreturnsmanifest/viewreturnsmanifest.component.js